import React from "react";
import { connect } from "react-redux";
import Tooltip from "@/tooltip";
import { Actions as DEPUTY_ACTIONS } from "./deputy/store/deputyActions";
import DeputyEmployeeLink from "./deputy/DeputyEmployeeLink";
import WorkforceEmployeeLink from "./workforce/WorkforceEmployeeLink";
import BambooEmployeeLink from "./bamboo-hr/BambooEmployeeLink";
import { useMemo } from "react";
import QuickbooksEmployeeLink from "./quickbooks/QuickbooksEmployeeLink";
import SmartPensionLink from "./smartPension/SmartPensionEmployeeLink";

const IntegrationTimesheetImport = ({ deputyConnected, integrations, value, onChange, disabled, agreementInfo }) => {
	const integrationList = useMemo(() => {
		const allIntegrations = [...integrations];
		if (deputyConnected) allIntegrations.push("Deputy");
		return allIntegrations;
	}, [JSON.stringify(integrations), !!deputyConnected]);

	return (
		<>
			<div className="col-xs-3">
				<div className="form-material form-container">
					<label htmlFor="reference">
						<Tooltip content="The employee reference code is used when importing punches or timesheets, hence it needs to be synchronised with third party software. If you do not link with third party software you are free to use this code for internal reference purposes.">
							Employee Reference Code
						</Tooltip>
					</label>
					<input
						id="reference"
						name="reference"
						className="form-control form-input"
						value={value}
						onChange={(e) => onChange(e.target.name, e.target.value)}
						autoComplete="off"
						disabled={disabled}
					/>
				</div>
			</div>
			{integrationList.map((integration) => {
				if (integration == "Tanda") return <WorkforceEmployeeLink {...{ agreementInfo, disabled }} />;
				if (integration == "Deputy") return <DeputyEmployeeLink {...{ agreementInfo, disabled }} />;
				if (integration == "Bamboo HR") return <BambooEmployeeLink {...{ agreementInfo, disabled }} />;
				if (integration == "Quickbooks") return <QuickbooksEmployeeLink {...{ agreementInfo, disabled }} />;
				if (integration == "Smart Pension") return <SmartPensionLink {...{ agreementInfo, disabled }} />;
			})}
		</>
	);
};

const mapStateToProps = (state) => {
	const integrations = Object.values(state.integration || {})?.reduce((prev, curr) => {
		Object.values(curr || {})?.map((item) => {
			if (item.name) prev.push(item.name);
		});
		return prev;
	}, []);
	return {
		deputyConnected: state.deputy.connected,
		company: state?.company?.settings?.org,
		integrations,
	};
};

const mapDispatchToProps = (dispatch) => ({
	isConnectedWithDeputy: () => dispatch(DEPUTY_ACTIONS.isConnectedWithDeputy()),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationTimesheetImport);
